import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const AdminMainContainer = ({ children }) => {
  return (
    <Container
      className='py-5 d-print-block'
      style={{
        backgroundColor: 'white',
        boxShadow: '0 0 5px 0.1px #ccc',
        borderRadius: '5px',
      }}
    >
      <Row className='justify-content-md-center'>
        <Col xs={12} md={11}>
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default AdminMainContainer;
